<script setup lang="ts">
import type { Components } from '@/api/generated/api';
import ExternalMaterialList from '@/core/supportMeasures/ExternalMaterialList.vue';

withDefaults(
  defineProps<{
    materials: Components.Schemas.ExternalMaterialLinkDto[];
    readonly?: boolean;
    disabled?: boolean;
    noteTone?: boolean;
    showHeading?: boolean;
  }>(),
  {
    showHeading: false,
  },
);
const emit = defineEmits<{ 'update:materials': [ids: number[]] }>();
</script>

<template>
  <section v-if="materials.length" class="flex flex-col gap-sm">
    <h2
      v-if="showHeading"
      class="flex min-h-button items-center py-sm text-body font-semibold leading-body text-secondary"
    >
      {{ $t('supportMeasureEntry.linkedApps') }}
    </h2>

    <ExternalMaterialList
      :materials="materials"
      :readonly="readonly"
      :disabled="disabled"
      :removable="!readonly"
      :note-tone="noteTone"
      :surface="noteTone ? 'primary' : 'secondary'"
      @update:materials="emit('update:materials', $event)"
    />
  </section>
</template>
